import { render, staticRenderFns } from "./Reactivate.vue?vue&type=template&id=513b8bbc&scoped=true"
import script from "./Reactivate.vue?vue&type=script&lang=js"
export * from "./Reactivate.vue?vue&type=script&lang=js"
import style0 from "./Reactivate.vue?vue&type=style&index=0&id=513b8bbc&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "513b8bbc",
  null
  
)

export default component.exports